import { useState }     from 'react';
import { Container }    from '@material-ui/core';
import { connect }      from 'react-redux';
import { toast }        from 'react-toastify';
// Redux
import {changeView}             from '../../redux/actions/Menu';
import {updateNotifications}    from '../../redux/actions/Notifications';
// Components
import Input        from '../global/Input';
import ButtonsForm  from '../global/ButtonsForm';
// Values
import {StateView, toastText, notificationValue} from '../../values';
// Styles
import {useStyles} from '../../style';
// Api
import {updateData, postData, deleteData, dataValidate}   from '../../utils/notifications';

const Form = ({data, token, stateView, changeView, updateNotifications}) => {
    const classes                   = useStyles()
    const [blockData, setblockData] = useState(stateView===StateView.state2?"":"disabled")
    // State buttons ----------------------------------------------------------------
    const [edit, setEdit]           = useState(0)
    const [erase, setErase]         = useState(0)
    const [add, setAdd]             = useState(0)

    // Data -------------------------------------------------------------------------
    const [schedule, setSchedule]   = useState(data.Schedule?data.Schedule:'MORNING')
    const [title, setTitle]         = useState(data.Title?data.Title:'')
    const [message, setMessage]     = useState(data.Message?data.Message:'')

    // Functions --------------------------------------------------------------------
    const Back = () =>{
        changeView(StateView.state1)
        updateNotifications([])
    }

    const Edit = async() =>{
        const value = edit + 1
        setEdit(value)
        setblockData('')
        if(value===2){
            const validate = dataValidate(title, message)
            if(validate.flag){
                const res = await updateData(data.Id, token, title, message, schedule)
                if(res){
                    toast.success(toastText.update)
                    console.log(toastText.update)
                    changeView(StateView.state1)
                    updateNotifications([])
                } else{
                    toast.warn(toastText.warning)
                    console.log(toastText.warning)
                    setEdit(1)
                }
            } else{
                toast.warn(validate.message)
                console.log(validate.message)
                setEdit(1)
            }
        }
    }
    const Add = async() =>{
        const value = add + 1
        setAdd(value)
        if(value===1){
            const validate = dataValidate(title, message)
            if(validate.flag){
                const res = await postData(token, title, message, schedule)
                if(res){
                    toast.success(toastText.add)
                    console.log(toastText.add)
                    changeView(StateView.state1)
                } else{
                    toast.warn(toastText.warning)
                    console.log(toastText.warning)
                    setAdd(0)
                }
            } else{
                toast.warn(validate.message)
                console.log(validate.message)
                setAdd(0)
            }
        }
    }
    const Delete = async() =>{
        const value = erase + 1
        setErase(value)
        if(value===1){
            const res = await deleteData(data.Id, token)
            if(res){
                toast.success(toastText.delete)
                console.log(toastText.delete)
                changeView(StateView.state1)
                updateNotifications([])
            } else{
                toast.warn(toastText.warning)
                console.log(toastText.warning)
                setErase(0)
            }
        }
    }
    return (
        <Container maxWidth="xl">
            <div style={{background:'#fff', paddingBottom:50, paddingTop:20}}>
                <Container maxWidth="xl">
                    <Input title={'Titulo'} value={title} setData={setTitle} blockData={blockData} />
                    <Input title={'Mensaje'} value={message} setData={setMessage} blockData={blockData} />
                    <div style={{display:'flex', alignContent:'center', maxWidth:700, width:'100%'}}>
                        <p className={classes.title_input}>{'Periodo'}</p>
                        <select style={{cursor:blockData === 'disabled' ? '' : 'pointer'}}
                            defaultValue={schedule} 
                            className={classes.select} 
                            onChange={e => setSchedule(e.target.value)}
                            disabled={blockData}>
                                <option  value={notificationValue.value1}>{notificationValue.text1}</option>
                                <option  value={notificationValue.value2}>{notificationValue.text2}</option>
                        </select>
                    </div>
                </Container>
            </div>
            <ButtonsForm View={stateView} Back={Back} Edit={Edit} edit={edit} Add={Add} add={add} Delete={Delete} erase={erase} />
        </Container>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    data:           state.Notifications.notificationsEdit,
    token:          state.Panel.token,
})

export default connect(mapStateToProps, {changeView, updateNotifications})(Form);
